<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import Qrcode from "@/components/widgets/qrcode";

export default {
  locales: {
    en: {
    },
    pt: {
    },
    es: {
    },
  },
  components: {
    Layout,
    Qrcode,
  },
  data() {
    return {
      tickets: null,

      ticket: {
        modal: false,
        event: {
          name: '',
          date: '',
          cover: '',
        },
        code: '',
      }
    };
  },
  methods: {
    getTickets() {
      this.tickets = null;

      api
        .get("events/tickets")
        .then((response) => {
          if (response.data.status == "success") {
            this.tickets = response.data.list;
          }
        })
        .catch((error) => {
          if (error) {
            this.tickets = [];
          }
        })
    },
    showTicket(row) {
      this.ticket.event = row.event;
      this.ticket.code = row.code;
      this.ticket.modal = false;
      this.ticket.modal = true;
    },
  },
  mounted() {
    this.getTickets();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/events">Eventos</router-link></li>
      <li class="breadcrumb-item d-none d-sm-block">Meus Ingressos</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Meus Ingressos</h3>
        <p></p>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="min-vh-25 text-center d-flex justify-content-center align-items-center" v-if="!tickets">
          <b-spinner variant="default" role="status"></b-spinner>
        </div>

        <div v-else-if="tickets && tickets.length == 0" class="min-vh-25 text-center d-flex justify-content-center align-items-center">
          <div>
            <i class="far fa-sad-cry font-size-24"></i><br>
            nenhum registro encontrado
          </div>
        </div>

        <div v-else class="table-responsive">
          <table class="table table-centered table-nowrap">
            <thead class="thead-light">
              <tr>
                <th>Evento</th>
                <th>Código</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in tickets" :key="row.index">
                <td>{{ row.event.name }}</td>
                <td>{{ row.code }}</td>
                <td>
                  <span v-if="row.status == 'available'" class="badge badge-soft-default font-size-13 text-uppercase">Disponível</span>
                  <span v-else-if="row.status == 'used'" class="badge badge-soft-success font-size-13 text-uppercase">Utilizado</span>
                </td>
                <td class="text-right">
                  <button class="btn btn-default btn-sm btn-rounded font-size-14" v-on:click="showTicket(row)">
                    Ver
                    <i class="mdi mdi-arrow-right ml-1"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <b-modal v-model="ticket.modal" :title="ticket.code" modal-class="modal-right" hide-footer>
      <div class="mb-3">
        <img v-if="ticket.event.cover" class="w-100 rounded" :src="ticket.event.cover" />
        <div class="p-2">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <h5 class="mb-1">{{ ticket.event.name }}</h5>
              <div class="d-flex align-items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
                  <path d="M7 11h2v2H7zm0 4h2v2H7zm4-4h2v2h-2zm0 4h2v2h-2zm4-4h2v2h-2zm0 4h2v2h-2z"></path>
                  <path d="M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM19 8l.001 12H5V8h14z"></path>
                </svg>
                <div class="ml-1 text-dark font-weight-bold">{{ ticket.event.date }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center">
        <qrcode :value="ticket.code" />
        <div class="font-size-18">
          {{ ticket.code }}
        </div>
      </div>
    </b-modal>
  </Layout>
</template>